var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    borders = _ref.borders,
    colors = _ref.colors;
  return {
    blankTextMargin: spacing.xSmall,
    numCircleBorderWidth: borders.widthSmall,
    numCircleBorderColor: colors.contrasts.grey4570,
    numCircleColor: colors.contrasts.grey4570,
    numCircleMargin: spacing.xxSmall,
    selectWrapperPadding: spacing.xSmall,
    optionsWrapperMargin: spacing.xSmall
  };
};
export default generateComponentTheme;